export enum ChannelClient {
  TLN = 1,
  TERRAVITA = 2,
  EIYOLAB = 3,
  B2B = 4,
  AMAZON = 5,
}

export const ChannelClientTranslations: Record<ChannelClient, string> = {
  [ChannelClient.TLN]: 'Toutelanutrition & Boutique',
  [ChannelClient.TERRAVITA]: 'Terravita',
  [ChannelClient.EIYOLAB]: 'Eiyolab',
  [ChannelClient.B2B]: 'BtoB',
  [ChannelClient.AMAZON]: 'Amazon',
};

export const ChannelClientSelects = (Object.keys(ChannelClientTranslations) as unknown as ChannelClient[]).map(
  (channelClient) => ({
    value: channelClient,
    label: ChannelClientTranslations[channelClient],
  }),
);
